export var Undetermined = 0;
export var Synchronous = 1;
export var Asynchronous = 2;
